import { Card, Col, Row } from "react-bootstrap";
import { IIncidentDetails } from "../../../api/IIncident";
import { ILicenceProfile } from "../../../api/LicenceProfile";
import EpaField2Rows from "../../../leap-components/EpaField2Rows";
import { IncidentIcon } from "../../../leap-components/icons/LeapIcons";

interface IncidentHeaderProps {
  incidentDetails: IIncidentDetails;
  licenceProfile: ILicenceProfile;
}

const IncidentHeader = ({
  incidentDetails,
  licenceProfile,
}: IncidentHeaderProps) => {
  return (
    <Card className="flex-fill w-100">
      <Card.Header></Card.Header>
      <Card.Body className="pt-0">
        <Row>
          <Col className="col-12 col-md-6">
            <table className="no-border" style={{ marginTop: "0.6rem" }}>
              <tbody>
                <tr>
                  <td>
                    <IncidentIcon />
                  </td>
                  <td>
                    <h2>Incident: {incidentDetails.reference}</h2>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="d-md-none" style={{ height: "20px" }}></div>
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows
              label={"Reference No."}
              value={incidentDetails.reference}
            />
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows label={"Status"} value={incidentDetails.status} />
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows
              label={"Authorisation Version"}
              value={incidentDetails.licence_regno}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default IncidentHeader;
